import { render } from "./App.vue?vue&type=template&id=9d7d6f28"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9d7d6f28&lang=css"
script.render = render

export default script